var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSizeArrowDown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 4,
    viewBox: "0 0 4 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00001 2.50226L3.34391 0.76123L3.75293 1.29111L2.00001 3.56202L0.247086 1.29111L0.656101 0.76123L2.00001 2.50226Z",
    fill: "#1D1B20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSizeArrowDown);
export default __webpack_public_path__ + "static/media/sizeArrowDown.2fe6e93640c47dfce7c36b5467b0da94.svg";
export { ForwardRef as ReactComponent };